import {
  Component,
  inject,
  input,
  type OnChanges,
  type SimpleChanges,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { Routes } from '@core/routes/routes';
import { ButtonModule } from '@fino-ui/button';
import { FinoCommonModule } from '@fino-ui/common';
import { FinoTranslationModule } from '@fino-ui/translation';
import { filter } from 'lodash';
import { IdentifyDocumentService } from '../identify-document.service';

@Component({
  selector: 'app-siblings',
  templateUrl: './siblings.component.html',
  imports: [ButtonModule, FinoTranslationModule, FinoCommonModule],
})
export class SiblingsComponent implements OnChanges {
  private readonly router = inject(Router);
  private readonly identifyDocumentService = inject(IdentifyDocumentService);

  readonly jobId = input<string>('');

  numSiblings = signal(0);
  numSiblingsOpen = signal(0);

  ngOnChanges(changes: SimpleChanges) {
    if (changes.jobId?.currentValue) {
      this.countSiblings();
    }
  }

  mergeSiblings() {
    const jobId = this.jobId();
    if (!jobId) {
      alert(`Job ID is not set: ${jobId}`);
    }

    this.router.navigate([Routes.MergeSiblings, jobId]);
  }

  countSiblings() {
    this.identifyDocumentService
      .getSiblings(this.jobId())
      .subscribe((siblings: any) => {
        this.numSiblings.set((siblings as []).length);
        this.numSiblingsOpen.set(
          filter(siblings as [], (s: any) => s.status === 'open').length,
        );
      });
  }
}
